import moment from "moment";
import React, { useRef } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { AxiosInstance } from "../../../../axios";
import ViewBookSet from "../BookModule/BookModule.module.css";
import { ImageUrlPrefix, R_PER_PAGE } from "../../../../labels";
import Loader from "../../Loader";
import axios from "axios";
import fileDownload from "js-file-download";
import { Modal } from "react-bootstrap";
import { Chip, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Search } from "@mui/icons-material";
import Pagination from "../../../ReusuableComponent/Pagination/Pagination";
import CustomDownloadButton from "../../../ReusuableComponent/CustomDownloadButton/CustomDownloadButton";
import toast from "react-hot-toast";

export default function DSchedule() {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    id,
    types,
    coures_name,
    category_course_id,
    sEmail,
    subcate,
  } = location.state;

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, [id]);
  let currentTime = moment();
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("User Id cannot avaliable in session storage");
  }
  const [open, setOpen] = useState(false);
  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));
  let page = R_PER_PAGE;
  const answer_sheet_ref = useRef(null);
  const filterRef_batch_name = useRef(null);
  const txtBSearch_batch_name = useRef(null);
  const filterRef_section = useRef(null);
  const filterRef_class_mode = useRef(null);
  const filterRef_medium = useRef(null);
  const filterRef_schedule = useRef(null);
  const filterRef_location = useRef(null);
  const filterRef_status = useRef(null);
  const txtBSearch = useRef(null);
  const [section, setSection] = useState([]);
  const [medium, setMedium] = useState([]);
  const [classMode, setClassMode] = useState([]);
  const [schedule, setSchedule] = useState([]);

  const [updateListData, setUpdateListData] = useState();
  const [csvData, setCsvData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [sortOrder, setSortOrder] = useState("asc");
  const [isOpen, setIsOpen] = useState({
    batch_name: false,
    section: false,
    medium: false,
    class_mode: false,
    schedule: false,
    location: false,
    status: false,

  });
  const [searchTerm, setSearchTerm] = useState("");
  const [updateChipData, setUpdateChipData] = useState([]);
  const [batch_name, setBatch_name] = useState([]);
  const [medium_on, setMedium_on] = useState([]);

  const [status, setStatus] = useState([]);
  const [locationsId, setlocationsId] = useState([]);
  const [locations, setLocations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    const handleClickOutside = (event) => {
      const isCheckbox = event.target.closest('input[type="checkbox"]');
      const isApplyFilterButton = event.target.closest(".filterBoxs_testlist");
      const isChipData = event.target.closest(".paperil_global");
      if (isCheckbox || isApplyFilterButton || isChipData) return;
      if (filterRef_batch_name.current &&
        !filterRef_batch_name.current.contains(event.target)) {
        {
          const hasBatch = updateChipData.some(
            (chipItem) => chipItem.type === "batch_name"
          );
          if (hasBatch) {
            const updatedAuthor = updateChipData.filter(
              (chipItem) => chipItem.type === "batch_name"
            );
            setBatch_name(updatedAuthor);
          } else {
            setBatch_name([]);
          }
          setIsOpen((prev) => ({ ...prev, batch_name: false }));
        }
      }
      if (filterRef_section.current &&
        !filterRef_section.current.contains(event.target)) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "section"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "section"
            );
            setSection(updatedCategory);
          } else {
            setSection([]);
          }
          setIsOpen((prev) => ({ ...prev, section: false }));
        }
      }
      if (filterRef_medium.current &&
        !filterRef_medium.current.contains(event.target)) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "medium"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "medium"
            );
            setMedium_on(updatedCategory);
          } else {
            setMedium_on([]);
          }
          setIsOpen((prev) => ({ ...prev, medium: false }));
        }
      }
      if (filterRef_class_mode.current &&
        !filterRef_class_mode.current.contains(event.target)) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "class_mode"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "class_mode"
            );
            setClassMode(updatedCategory);
          } else {
            setClassMode([]);
          }
          setIsOpen((prev) => ({ ...prev, class_mode: false }));
        }
      }
      if (filterRef_schedule.current &&
        !filterRef_schedule.current.contains(event.target)) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "schedule"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "schedule"
            );
            setSchedule(updatedCategory);
          } else {
            setSchedule([]);
          }
          setIsOpen((prev) => ({ ...prev, schedule: false }));
        }
      }
      if (filterRef_location.current &&
        !filterRef_location.current.contains(event.target)) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "location"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "location"
            );
            setLocations(updatedCategory);
          } else {
            setLocations([]);
          }
          setIsOpen((prev) => ({ ...prev, location: false }));
        }
      }

      if (filterRef_status.current &&
        !filterRef_status.current.contains(event.target)) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "status"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "status"
            );
            setStatus(updatedCategory);
          } else {
            setStatus([]);
          }
          setIsOpen((prev) => ({ ...prev, status: false }));
        }
      }

    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [updateChipData, batch_name, section, medium, classMode, schedule, locations, status]);

  const fetchEventData = () => {
    setIsLoading(true);
    AxiosInstance.post("api/event/findById", {
      id: id,
      staff_id: "",
      event_type: types === "1" || types === 1 ? 1 : 0,
      // event_type: "",

    })
      .then((res) => {
        if (res.data.status === true) {
          setIsLoading(false);

          let el = res.data.data;
          // setUpdateListData([]);
          setFdata((prevFdata) => ({
            ...prevFdata,
            title: el.name,
            sDate:
              el.start_date !== null
                ? moment(el.start_date).format("YYYY-MM-DD")
                : "",
            startTime: el.start_time,
            endTime: el.end_time,
            subject: el.subject,
            staff_name: el.staff_name,
            description: el.description,
            batchName: el.batch_name,
            category: el.category,
            course: el.category_class,
            classMode: el.class_mode,
            medium: el.medium,
            location: el.location,
            teams_url: el.teams_url,
            recording_url: el.recording_url,
            cut_off: el.cut_off,
            batch_id: el.batch_id,
            event_id: el.id,
            test_num: el.test_no,
            test_topic: el.test_topic,
            tol_mark: el.tot_marks,
            no_ques: el.no_of_questions,
            syllabus_path: el.syllabus_filepath,
            staff_dec: el.staff_description,
            method_of_test: el.method_of_test,
            double_evaluation: el.double_evaluation,
            attendance_sheet_path: el.attendance_sheet_frame,
            original_attendancesheet_file_path: el.original_attendancesheet_file_path,
            que_status: el.que_status,
            qpath: el.que_paper_filepath,
            qpath_original_path: el.original_que_paper_filepath,
            answer_booklet_original_path: el.answer_booklet_original_path
              ? el.answer_booklet_original_path
              : null,
            answer_booklet_path: el.answer_booklet_path
              ? el.answer_booklet_path
              : null,
            question_frameset_path: el.question_frame_path
              ? el.question_frame_path
              : null,
            question_frameset_original_path: el.question_frame_original_path
              ? el.question_frame_original_path
              : null,
            answer_key_path: el.answer_key_path ? el.answer_key_path : null,
            answer_key_original_path: el.answer_key_original_path
              ? el.answer_key_original_path
              : null,
          }));
          const subTopics =
            el.subject_test_topics && el.subject_test_topics.length > 0
              ? el.subject_test_topics
              : [];

          setSubTopic(subTopics);

          const OtherApplicableBatches =
            el.oth_app_batch && el.oth_app_batch.length > 0
              ? el.oth_app_batch
              : [];

          setOth_app_batch(OtherApplicableBatches);
        } else {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        return error;
      });
  }
  useEffect(() => {
    fetchEventData();
  }, []);

  // function locationsList() {
  //   AxiosInstance.post("api/branch/list")
  //     .then((res) => {
  //       if (res.data.status) {
  //         let branches = res.data.data.map((item) => ({
  //           id: item.id,
  //           name: item.name,
  //           phoneNumber: item.mobile_no,
  //           address: item.address,
  //           pincode: item.zipcode,
  //         }));
  //         setlocationsId(branches);
  //       } else {
  //         setlocationsId([]);
  //       }

  //     })
  //     .catch((error) => {
  //       return error;
  //     });
  // }
  // useEffect(() => {
  //   filterMedium = medium_on;
  // }, [medium_on]);
  // useEffect(() => {
  //   filterBatchName = batch_name;
  // }, [batch_name]);
  // useEffect(() => {
  //   loadListdata();
  // }, [updateChipData]);
  // useEffect(() => {
  //   locationsList();
  // }, [])
  const [fdata, setFdata] = useState({
    title: "",
    sDate: "",
    startTime: "",
    endTime: "",
    subject: "",
    staff_name: "",
    description: "",
    batchName: "",
    category: "",
    course: "",
    classMode: "",
    medium: "",
    location: "",
    teams_url: "",
    batch_id: "",
    event_id: "",
    test_num: "",
    test_topic: "",
    tol_mark: "",
    no_ques: "",
    syllabus_path: null,
    staff_dec: "",
    method_of_test: "",
    cut_off: null,
    que_status: null,
    qpath: null,
    qpath_original_path: null,
    answer_booklet_original_path: null,
    answer_booklet_path: null,
    question_frameset_path: null,
    question_frameset_original_path: null,
    answer_key_path: null,
    answer_key_original_path: null,
    assign_to: "",
    assign_to_name: "",
    event_type: "",
    cutOff: "",
    publish_results: null,
    double_evaluation: null,
    attendance_sheet_path: null,
    original_answer_sheet_path: null
  });
  const [error, setError] = useState({});
  const [subTopic, setSubTopic] = useState([]);
  const [oth_app_batch, setOth_app_batch] = useState([]);
  const handleMeeting = () => {
    window.open(fdata.teams_url, "_blank");
  };
  const handleEdit = () => {
    const sDate = fdata.sDate;
    const batch_id = fdata.batch_id;
    const category = fdata.category;
    const startTime = fdata.startTime;
    const endTime = fdata.endTime;
    const ClassMode = fdata.classMode;
    const type = types;
    const sEmailsss = sEmail

    navigate(`/CreateEvent`, {
      state: {
        id,
        sDate,
        batch_id,
        category,
        startTime,
        endTime,
        type,
        coures_name,
        category_course_id,
        subcate,
        ClassMode,
        sEmailsss
      },
    });

    // navigate(`/CreateEvent/${id}/${fdata.sDate}/${fdata.batch_id}/${fdata.category}/${fdata.startTime}/${fdata.endTime}`)
  };
  const navigateToPreviousScreen = () => {
    navigate(-2); // Navigate back by one step in the history
  };
  const handleDownloadSyllabus = (path) => {
    window.open(`${ImageUrlPrefix}/${path}`);
  };
  const startDate = moment(fdata.sDate, "YYYY-MM-DD");
  const startTime = moment(fdata.startTime, "HH:mm:ss");

  const StartDateTime = moment(
    `${currentTime.format("YYYY-MM-DD")} ${startTime.format("HH:mm:ss")}`,
    "YYYY-MM-DD HH:mm:ss"
  );
  const StartDateTime_class_event = moment(
    `${currentTime.format("YYYY-MM-DD")} ${startTime.format("HH:mm:ss")}`,
    "YYYY-MM-DD HH:mm:ss"
  );
  const endTime = moment(fdata.endTime, "HH:mm:ss");
  const endDateTime = moment(
    `${currentTime.format("YYYY-MM-DD")} ${endTime.format("HH:mm:ss")}`,
    "YYYY-MM-DD HH:mm:ss"
  );
  const isAfterStartDate = currentTime.isAfter(startDate, "day");
  const isAfterStartTime = currentTime.isAfter(StartDateTime);
  const isAfterStartTime_classEvent = currentTime.isAfter(
    StartDateTime_class_event
  );
  const isSameDay = currentTime.isSame(startDate, "day");
  const isPastDay = currentTime.isAfter(startDate, "day");
  const isAfterEndTimeONEHOUR =
    !isSameDay ||
    (isSameDay && currentTime.isAfter(endDateTime.clone().add(1, "hour")));
  // const handleDownload = (url, filename) => {
  //   axios
  //     .get(`${ImageUrlPrefix}/${fdata.attendance_sheet_path}`, {
  //       responseType: "blob",
  //     })
  //     .then((res) => {
  //       fileDownload(res.data, filename);
  //     })
  //     .catch((error) => {
  //       console.error("Download failed:", error);
  //     });
  // };


  // const handleShow = (doE) => {
  //   setOpen(true);
  // };
  //  const handleModalClose = () => {
  //   setOpen(false);
  // }
  // const handleClose = () => {
  //   try {
  //     {
  //       // If no id is provided, add the new data
  //       const createAnnouncementData = {
  //         id: id,
  //         created_by: userid,
  //         path: fdata.AttendancesheetPath,
  //         original_filepath: fdata.answer_sheet_original_path,
  //         recording_url: fdata.iframe
  //       };
  //       AxiosInstance.post(`api/test/upload/attendancesheet`, createAnnouncementData)
  //         .then((res) => {
  //           // console.log(res);
  //           if (res.data.status) {
  //             toast.success(res.data.message);
  //             setOpen(false);
  //             fetchEventData();
  //           } else {
  //             toast.error(res.data.message);
  //             setOpen(false);
  //           }
  //         })
  //         .catch((error) => {
  //           setOpen(false);
  //           return error;
  //         });
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     setOpen(false);
  //   }
  // };
  // let filterSearch = [];
  // let filterBatchName = [];
  // let filterSection = [];
  // let filterClassMode = [];
  // let filterSchedule = [];
  // let filterLocation = [];
  // let filterMedium = [];
  // let filterStatus = [];
  // const handleSearch = (event) => {
  //   if (event.key === "Enter") {
  //     let val = event.target.value;
  //     updateStateData();
  //     setSearchTerm(val);
  //     if (val.length > 0) {
  //       filterSearch = [{ name: "" + val, type: "search" }];
  //     } else {
  //       filterSearch = [];
  //     }
  //     loadChipdata();
  //   }
  // };
  // const handleSearchFocus = () => {
  //   if (txtBSearch.current) {
  //     txtBSearch.current.focus();

  //     // Create a new KeyboardEvent
  //     const event = new KeyboardEvent("keydown", {
  //       key: "Enter",
  //       keyCode: 13,
  //       which: 13,
  //       code: "Enter",
  //       bubbles: true,
  //     });

  //     // Dispatch the event
  //     txtBSearch.current.dispatchEvent(event);
  //   }
  // };
  // const handleCheckboxChange = (event, names, typename) => {
  //   const { value, checked, name } = event.target;
  //   if (typename === "batch_name") {
  //     if (checked) {
  // setBatch_name([...batch_name,{ id: value, name: name, type: "batch_name" }]);
  //     } else {
  //       setBatch_name(batch_name.filter((item) => item.id !== value));
  //     }
  //   } else if (typename === "section") {
  //     if (checked) {
  //       setSection([{ id: value, name: name, type: "section" }]);
  //     } else {
  //       setSection(section.filter((item) => item.id !== value));
  //     }
  //   } else if (typename === "schedule") {
  //     if (checked) {
  //       setSchedule([{ id: value, name: name, type: "schedule" }]);
  //     } else {
  //       setSchedule(schedule.filter((item) => item.id !== value));
  //     }
  //   } else if (typename === "class_mode") {
  //     if (checked) {
  //       setClassMode([{ id: value, name: name, type: "class_mode" }]);
  //     } else {
  //       setClassMode(classMode.filter((item) => item.id !== value));
  //     }
  //   } else if (typename === "medium") {
  //     if (checked) {
  //       setMedium_on([{ id: value, name: name, type: "medium" }]);
  //     } else {
  //       setMedium_on(medium_on.filter((item) => item.id !== value));
  //     }
  //   } else if (typename === "location") {
  //     if (checked) {
  //      setLocations([...locations,{ id: value, name: name, type: "location" }]);
  //     } else {
  //       setLocations(locations.filter((item) => item.id !== value));
  //     }
  //   } else if (typename === "status") {
  //     if (checked) {
  //       setStatus([{ id: value, name: name, type: "status" }]);
  //     } else {
  //       setStatus(status.filter((item) => item.id !== value));
  //     }
  //   }
  // };
  // function updateStateData() {
  //   filterBatchName = batch_name;
  //   filterSection = section;
  //   filterClassMode = classMode;
  //   filterSchedule = schedule;
  //   filterLocation = locations;
  //   filterMedium = medium_on;
  //   filterStatus = status;
  //   if (searchTerm.length > 0) {
  //     filterSearch = [{ name: "" + searchTerm, type: "search" }];
  //   } else {
  //     filterSearch = [];
  //   }
  // }
  // function loadChipdata() {
  //   let tempArr = [];
  //   filterSearch.map((obj) => {
  //     tempArr.push(obj);
  //   });
  //   filterBatchName.map((obj) => {
  //     tempArr.push(obj);
  //   });

  //   filterSection.map((obj) => {
  //     tempArr.push(obj);
  //   });
  //   filterMedium.map((obj) => {
  //     tempArr.push(obj);
  //   });
  //   filterClassMode.map((obj) => {
  //     tempArr.push(obj);
  //   });
  //   filterSchedule.map((obj) => {
  //     tempArr.push(obj);
  //   });
  //   filterLocation.map((obj) => {
  //     tempArr.push(obj);
  //   });
  //   filterStatus.map((obj) => {
  //     tempArr.push(obj);
  //   });
  //   setUpdateChipData(tempArr);
  // }
  // const handleClear = (name) => {
  //   const updatedChips = updateChipData.filter((item) => item.type !== name);
  //   setUpdateChipData(updatedChips);
  //   setIsOpen({
  //     batch_name: false,
  //     section: false,
  //     medium: false,
  //     class_mode: false,
  //     schedule: false,
  //     location: false,
  //     status: false,
  //   });
  //   if (name === "batch_name") {
  //     setBatch_name([]);
  //     filterBatchName = [];
  //   } else if (name === "section") {
  //     setSection([]);
  //     filterSection = [];
  //   } else if (name === "medium") {
  //     setMedium_on([]);
  //     filterMedium = [];
  //   } else if (name === "class_mode") {
  //     setClassMode([]);
  //     filterClassMode = [];
  //   } else if (name === "schedule") {
  //     setSchedule([]);
  //     filterSchedule = [];
  //   } else if (name === "location") {
  //     setLocations([]);
  //     filterLocation = [];
  //   }
  //   else if (name === "status") {
  //     setStatus([]);
  //     filterStatus = [];
  //   }
  // };

  // const handleAllClear = () => {
  //   setSearchTerm([]);
  //   setBatch_name([]);
  //   setSection([]);
  //   setMedium_on([]);
  //   setClassMode([]);
  //   setSchedule([]);
  //   setLocations([]);
  //   setStatus([]);
  //   setUpdateChipData([]);
  // };
  // const handleFilter = (e, boxName) => {
  //   if (boxName === "batch_name") {
  //     setIsOpen((prevState) => ({
  //       ...prevState, // Retain the current state values
  //       batch_name: !prevState.batch_name, // Toggle the value
  //       section: false,
  //       medium: false,
  //       class_mode: false,
  //       schedule: false,
  //       location: false,
  //       status: false,
  //     }));
  //     setBatch_name(updateChipData.filter((ui) => ui.type === "batch_name"));
  //   } else if (boxName === "section") {
  //     setIsOpen((prevState) => ({
  //       ...prevState, // Retain the current state values
  //       section: !prevState.section,// Toggle the value
  //       batch_name: false,
  //       medium: false,
  //       class_mode: false,
  //       schedule: false,
  //       location: false,
  //       status: false,
  //     }));
  //     setSection(updateChipData.filter((ui) => ui.type === "section"));
  //   } else if (boxName === "medium") {
  //     setIsOpen((prevState) => ({
  //       ...prevState, // Retain the current state values
  //       medium: !prevState.medium, // Toggle the value
  //       batch_name: false,
  //       section: false,
  //       class_mode: false,
  //       schedule: false,
  //       location: false,
  //       status: false,
  //     }));
  //     setMedium(updateChipData.filter((ui) => ui.type === "medium"));
  //   } else if (boxName === "class_mode") {
  //     setIsOpen((prevState) => ({
  //       ...prevState, // Retain the current state values
  //       class_mode: !prevState.class_mode, // Toggle the value
  //       batch_name: false,
  //       section: false,
  //       medium: false,
  //       schedule: false,
  //       location: false,
  //       status: false,
  //     }));
  //     setClassMode(updateChipData.filter((ui) => ui.type === "class_mode"));
  //   } else if (boxName === "schedule") {
  //     setIsOpen((prevState) => ({
  //       ...prevState, // Retain the current state values
  //       schedule: !prevState.schedule, // Toggle the value
  //       batch_name: false,
  //       section: false,
  //       medium: false,
  //       class_mode: false,
  //       location: false,
  //       status: false,


  //     }));
  //     setSchedule(updateChipData.filter((ui) => ui.type === "schedule"));
  //   } else if (boxName === "location") {
  //     locationsList();
  //     setIsOpen((prevState) => ({
  //       ...prevState, // Retain the current state values
  //       location: !prevState.location, // Toggle the value
  //       batch_name: false,
  //       section: false,
  //       medium: false,
  //       schedule: false,
  //       status: false,
  //       class_mode: false
  //     }));
  //     setlocationsId(updateChipData.filter((ui) => ui.type === "location"));
  //   } else if (boxName === "status") {
  //     setIsOpen((prevState) => ({
  //       ...prevState, // Retain the current state values
  //       status: !prevState.status, // Toggle the value
  //       batch_name: false,
  //       section: false,
  //       medium: false,
  //       schedule: false,
  //       location: false,
  //       class_mode: false,
  //     }));
  //     setStatus(updateChipData.filter((ui) => ui.type === "status"));
  //   }


  // };
  // const handleApplyFilter = (name, event) => {
  //   updateStateData();
  //   if (name === "batch_name") {
  //     loadChipdata();
  //     setIsOpen({
  //       ...isOpen,
  //       batch_name: false,
  //     });
  //   } else if (name === "section") {
  //     loadChipdata();
  //     setIsOpen({
  //       ...isOpen,
  //       section: false,
  //     });
  //   } else if (name === "medium") {
  //     loadChipdata();
  //     setIsOpen({
  //       ...isOpen,
  //       medium: false,
  //     });
  //   } else if (name === "class_mode") {
  //     loadChipdata();
  //     setIsOpen({
  //       ...isOpen,
  //       class_mode: false,
  //     });
  //   } else if (name === "schedule") {
  //     loadChipdata();
  //     setIsOpen({
  //       ...isOpen,
  //       schedule: false,
  //     });
  //   } else if (name === "location") {
  //     loadChipdata();
  //     setIsOpen({
  //       ...isOpen,
  //       location: false,
  //     });
  //   } else if (name === "status") {
  //     loadChipdata();
  //     setIsOpen({
  //       ...isOpen,
  //       status: false,
  //     });
  //   }
  // };
  // const handleDelete = (chipToDelete, index) => () => {
  //   updateStateData();
  //   if (chipToDelete.type === "search") {
  //     setSearchTerm("");
  //     filterSearch = [];
  //   } else if (chipToDelete.type === "batch_name") {
  //     setBatch_name(batch_name.filter((item) => item.id !== chipToDelete.id));
  //     filterBatchName = batch_name.filter((item) => item.id !== chipToDelete.id);
  //   } else if (chipToDelete.type === "section") {
  //     setSection(
  //       section.filter((item) => item.id !== chipToDelete.id)
  //     );
  //     filterSection = section.filter(
  //       (item) => item.id !== chipToDelete.id
  //     );
  //   } else if (chipToDelete.type === "medium") {
  //     setMedium_on(medium_on.filter((item) => item.id !== chipToDelete.id));
  //     filterMedium = medium_on.filter((item) => item.id !== chipToDelete.id);
  //   } else if (chipToDelete.type === "class_mode") {
  //     setClassMode(classMode.filter((item) => item.id !== chipToDelete.id));
  //     filterClassMode = classMode.filter(
  //       (item) => item.id !== chipToDelete.id
  //     );
  //   } else if (chipToDelete.type === "schedule") {
  //     setSchedule(schedule.filter((item) => item.id !== chipToDelete.id));
  //     filterSchedule = schedule.filter((item) => item.id !== chipToDelete.id);
  //   } else if (chipToDelete.type === "location") {
  //     setLocations(locations.filter((item) => item.id !== chipToDelete.id));
  //     filterLocation = locations.filter((item) => item.id !== chipToDelete.id);
  //   } else if (chipToDelete.type === "status") {
  //     setStatus(status.filter((item) => item.id !== chipToDelete.id));
  //     filterStatus = status.filter((item) => item.id !== chipToDelete.id);
  //   }
  //   loadChipdata();
  // };
  // // const handleSort = (event, sortKey) => {
  // //   event.preventDefault();
  // //   let order = sortOrder === "asc" ? "desc" : "asc";
  // //   setSortOrder(order);
  // //   let sortedList = updateListData.sort((a, b) => {
  // //     // let sortedList = currentData.sort((a, b) => {

  // //     if (a[sortKey] < b[sortKey]) {
  // //       return order === "asc" ? -1 : 1;
  // //     }
  // //     if (a[sortKey] > b[sortKey]) {
  // //       return order === "asc" ? 1 : -1;
  // //     }
  // //     if (a[sortKey] == b[sortKey]) {
  // //       return order === "asc" ? 1 : -1;
  // //     }
  // //     return 0;
  // //   });
  // //   setUpdateListData(sortedList);
  // // };
  // // useEffect(() => {
  // //   loadListdata();
  // //   if (searchTerm.length > 0) {
  // //     filterSearch = [{ name: "" + searchTerm, type: "search" }];
  // //   } else {
  // //     filterSearch = [];
  // //   }
  // // }, [searchTerm]);
  // // const loadListdata = () => {
  // //   let tempbatch = [];
  // //   let tempsection = [];
  // //   let tempmedium = [];
  // //   let tempclassMode = [];
  // //   let tempSchedule = [];
  // //   let templocation = [];
  // //   let tempstatus = [];
  // //   batch_name.map((obj) => {
  // //     tempbatch.push(obj.name);
  // //   });
  // //   section.map((obj) => {
  // //     tempsection.push(obj.name);
  // //   });
  // //   medium_on.map((obj) => {
  // //     tempmedium.push(obj.name);
  // //   });
  // //   classMode.map((obj) => {
  // //     tempclassMode.push(obj.name);
  // //   });
  // //   schedule.map((obj) => {
  // //     tempSchedule.push(obj.name);
  // //   });
  // //   locations.map((obj) => {
  // //     templocation.push(obj.name);
  // //   })
  // //   status.map((obj) => {
  // //     tempstatus.push(Number(obj.id));
  // //   })
  // //   const filters = {
  // //     search: searchTerm.length > 0 ? searchTerm : "",
  // //     event_id: id,
  // //     batch_name: batch_name.length > 0 ? tempbatch : "",
  // //     section: section.length > 0 ? tempsection : "",
  // //     medium: medium_on.length > 0 ? tempmedium : "",
  // //     class_mode: classMode.length > 0 ? tempclassMode : "",
  // //     batch_type: schedule.length > 0 ? tempSchedule : "",
  // //     location: locations.length > 0 ? templocation : "",
  // //     status: status.length > 0 ? tempstatus : "",
  // //   };
  // //   setIsLoading(true);
  // //   AxiosInstance.post("api/test/class/class_attend", filters)
  // //     .then((res) => {
  // //       if (res.data.status) {
  // //         setIsLoading(false);
  // //         setCurrentPage(1);
  // //         const fiata = res.data.data;
  // //         const serialNumberAddedData = fiata.map((data, index) => ({
  // //           ...data,
  // //           serialNumber: index + 1,
  // //         }));
  // //         setUpdateListData(serialNumberAddedData);
  // //         const csvFormattedData = serialNumberAddedData.map((item) => ({
  // //           serialNumber: item.serialNumber,
  // //           name: item.name,
  // //           email: item.email,
  // //           phone_no: item.phone_no,
  // //           batch_name: item.batch_name,
  // //           section: item.section,
  // //           medium: item.medium,
  // //           class_mode: item.class_mode,
  // //           batch_type: item.batch_type,
  // //           location: item.location,
  // //           status: item.status == 0 ? "Absent" : "Present",

  // //         }));
  // //         // Set CSV data
  // //         setCsvData(csvFormattedData);
  // //       } else if (res.data.status === false) {
  // //         setUpdateListData([]);
  // //         setIsLoading(false);
  // //       }
  // //     })
  // //     .catch((error) => {
  // //       setUpdateListData([]);
  // //       setIsLoading(false);
  // //       console.error("Error loading data:", error);
  // //     });
  // // };
  // const handleFilterSearchFocus = (name) => {
  //   if (name == "course") {
  //     if (txtBSearch_batch_name.current) {
  //       txtBSearch_batch_name.current.focus();
  //       // Create a new KeyboardEvent
  //       const event = new KeyboardEvent("keydown", {
  //         key: "Enter",
  //         keyCode: 13,
  //         which: 13,
  //         code: "Enter",
  //         bubbles: true,
  //       });
  //       // Dispatch the event
  //       txtBSearch_batch_name.current.dispatchEvent(event);
  //     }
  //   }
  // };
  // const handleFilterCourseSearch = (event, names) => {
  //   if (names == "batch_name") {
  //     const searchInput = event.target.value;


  //     if (searchInput !== "") {
  //       const matchingObjects = batchList.filter(
  //         (item) =>
  //           item.batch_name &&
  //           item.batch_name.toLowerCase().includes(searchInput.toLowerCase())
  //       );
  //       setBatchList(matchingObjects);
  //     } else {
  //       setBatchList(batchList);
  //     }
  //   }
  // };

  // const totalPages = Math.ceil(updateListData?.length / rowsPerPage);
  // prev button pagination
  // const handlePrev = (val) => {
  //   setCurrentPage(val);
  // };
  // next button pagination
  // const handleNext = (val) => {
  //   setCurrentPage(val);
  // };

  // const handlePageCount = (e) => {
  //   setRowsPerPage(Number(e.target.value));
  //   setCurrentPage(1);
  //   setUpdateListData([]);
  //   loadListdata();
  // };
  // pagination start end -   item per page changing
  // const start = (currentPage - 1) * rowsPerPage;
  // const end = start + rowsPerPage;
  // const currentData = csvListData.slice(start, end);

  // const currentData = updateListData?.slice(start, end);
  // const [batchList, setBatchList] = useState([]);
  // const [sectionList, setSectionList] = useState([]);

  // useEffect(() => {
  //   const uniqueBatch = Array.from(
  //     new Map(updateListData?.map((item) => [item.batch_name, item])).values()
  //   );

  //   const uniqueSection = Array.from(
  //     new Map(updateListData?.map((item) => [item.section, item])).values()
  //   );
  //   setBatchList(uniqueBatch);
  //   setSectionList(uniqueSection);

  // }, [updateListData])
  // const handleChange = (event) => {
  //   let { name, files, value } = event.target;
  //   if (name === "AttendancesheetPath") {
  //     if (files && files.length > 0) {
  //       const attendancesheet = files[0];
  //       setFdata((prevState) => ({
  //         ...prevState,
  //         AttendancesheetPath: null,
  //         answer_sheet_original_path: null,
  //       }));
  //       const allowedMimeTypes = ["text/csv", "application/vnd.ms-excel"];

  //       // Validate file type
  //       if (allowedMimeTypes.includes(files[0].type)) {
  //         // Validate file size (less than 10MB)
  //         if (files[0].size < 10 * 1024 * 1024) {
  //           const formData = new FormData();
  //           formData.append("attendancesheet", attendancesheet);

  //           // First API call
  //           AxiosInstance.post("/api/upload/", formData)
  //             .then((res) => {
  //               setFdata((prevState) => ({
  //                 ...prevState,
  //                 AttendancesheetPath: res.data.path,
  //                 answer_sheet_original_path: res.data.originalname,
  //               }));

  //               setError({
  //                 ...error,
  //                 AttendancesheetPath: "",
  //               });
  //             })
  //             .catch((error) => {
  //               console.error("Error in first API call:", error);
  //             });
  //         } else {
  //           let err = "File size must be less than 10MB.";
  //           setError({
  //             ...error,
  //             AttendancesheetPath: err,
  //           });
  //           setFdata((prevState) => ({
  //             ...prevState,
  //             AttendancesheetPath: null,
  //             question_f_original_path: null,
  //           }));
  //         }
  //       } else {
  //         // Handle invalid file type (e.g., PDF or other)
  //         let err = " CSV files only allowed.";
  //         setError({
  //           ...error,
  //           AttendancesheetPath: err,
  //         });
  //         setFdata((prevState) => ({
  //           ...prevState,
  //           AttendancesheetPath: null,
  //           answer_sheet_original_path: null,
  //         }));
  //       }
  //     } else {
  //       setFdata((prevState) => ({
  //         ...prevState,
  //         AttendancesheetPath: null,
  //         answer_sheet_original_path: null,
  //       }));
  //     }
  //   }
  //   // Update state
  //   setFdata((prevFields) => ({
  //     ...prevFields,
  //     [name]: value,
  //   }));

  // }





  // const generatePDF = () => {
  //   const headers = [
  //     "S.No",
  //     "Student Name",
  //     "Email",
  //     "Phone Number",
  //     "Batch Name",
  //     "Section",
  //     "Medium",
  //     "Class Mode",
  //     "Schedule Preference",
  //     "Location",
  //     "Status",
  //   ];

  //   const rows = csvData.map((item, index) => [
  //     index + 1,
  //     item.name ?? "-",
  //     item.email ?? "-",
  //     item.phone_no ?? "-",
  //     item.batch_name ?? "-",
  //     item.section ?? "-",
  //     item.medium ?? "-",
  //     item.class_mode ?? "-",
  //     item.batch_type ?? "-",
  //     item.location ?? "-",
  //     item.status == 0 ? "Absent" : "Present",
  //   ]);
  //   navigate("/preview", {
  //     state: {
  //       title: "Individual Books Data",
  //       headers,
  //       rows,
  //       filename: "IndividualBooks.pdf",
  //       autoPrint: true,
  //     },
  //   });
  // };
  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div className=" BathDet global_container">
      <div className="row">
        <div className="col-md-12">
          {/* <section className=" StepOne"> */}
          {/* <div className="heading  mt-3 d-flex justify-content-between "> */}
          {/* <h6 className={types != "1" ? "Tits" : "Titss"}>
                {" "}
                {types != "1" ? "View Class" : "View Test "}{" "}
              </h6> */}
          {/* <Link
                to="javascript:void(0)"
                onClick={() => navigateToPreviousScreen()}
                className="CancelButton mt-2"
              >
                Back to Batches
              </Link> */}
          <div className="row">
            <div className="col-md-2 col-12">
              <h2 className={`TitleHeader ${types != "1" ? "Tits" : "Titss"}`} >

                {types != "1" ? "View Class" : "View Test "}{" "}
              </h2>
            </div>
            <div className="col-md-10 col-12 ListBtn">
              <ul class="List-Button">
                <li class="ListBtnItems">
                  <Link
                    to="javascript:void(0)"
                    onClick={() => navigateToPreviousScreen()}
                    className="secondaryButton "
                    variant="secondary"
                  >
                    Back to View Batch
                  </Link>
                </li>
                {/* {fdata.attendance_sheet_path !== null && (
                  <>
                    <li class="ListBtnItems">
                      <Link
                        onClick={() => window.open(`${ImageUrlPrefix}/${fdata.attendance_sheet_path}`, "_blank")}
                        to={"javascript:void(0)"}
                        className={`primaryButton `}
                        variant="primary"
                      >
                        Download Attendance Frame Set
                      </Link>
                    </li>
                    <li class="ListBtnItems">
                      <Link
                        onClick={handleShow}
                        to={"javascript:void(0)"}
                        // disabled={
                        //   !(
                        //     isAfterEndTimeONEHOUR && selectedStudents.length > 0
                        //   )
                        // }
                        className={`primaryButton `}
                        variant="primary"
                      >
                        Add Url and Attendance Sheet
                      </Link>
                    </li>
                  </>
                )} */}

                {(types == "0" || types == 0) && (
                  <li class="ListBtnItems">
                    <Link
                      to={"javascript:void(0)"}
                      // disabled={isSameDay && isAfterStartTime_classEvent}
                      className={`primaryButton ${isSameDay && isAfterStartTime ? "DisabledListviS" : ""
                        }`}
                      // onClick={handleEdit}
                      onClick={(e) => {
                        if (isSameDay && isAfterStartTime) {
                          e.preventDefault(); 
                          return; 
                        }
                        handleEdit();
                      }}
                    >
                      <div className=" d-flex">
                        <span class="material-icons me-2 ">edit</span>
                        <span >
                          Edit Event
                        </span>
                      </div>
                    </Link>
                  </li>
                )}
                {(types == "1" || types == 1) && (
                  <li class="ListBtnItems">
                    <Link
                      to={"javascript:void(0)"}
                      disabled={isSameDay && isAfterStartTime}
                      className={`primaryButton ${isSameDay && isAfterStartTime ? "DisabledListviS" : ""
                        }`}
                      onClick={handleEdit}
                    >
                      <div className=" d-flex">
                        <span class="material-icons me-2">edit</span>
                        <span >
                          Edit Event
                        </span>
                      </div>
                    </Link>
                  </li>
                )}
                {types != "1" && (
                  <li class="ListBtnItems">
                    <Link
                      to={"javascript:void(0)"}
                      className={`primaryButton `}
                      onClick={fdata.teams_url !== null ? handleMeeting : undefined}
                      disabled={fdata.teams_url !== null ? false : true}
                    >
                      <div className=" d-flex">
                        <span class="material-icons me-2">event_available</span>
                        <span >
                          {types === "1" ? "View Test" : "Join Event"}
                        </span>
                      </div>

                    </Link>
                  </li>
                )}
              </ul>
            </div>
          </div>

          {/* {(types == "0" || types == 0) && (
                <button
                  type="button"
                  disabled={isSameDay && isAfterStartTime_classEvent}
                  className={`EditEventButton ${isSameDay && isAfterStartTime_classEvent
                    ? "DisabledListviS"
                    : ""
                    }`}
                  onClick={handleEdit}
                >
                  {" "}
                  <span class="material-icons ">edit</span>
                  <a href="javascript:void(0)">Edit Event</a>
                </button>
              )}
              {(types == "1" || types == 1) && (
                <button
                  type="button"
                  disabled={isSameDay && isAfterStartTime}
                  className={`EditEventButton ${isSameDay && isAfterStartTime ? "DisabledListviS" : ""
                    }`}
                  onClick={handleEdit}
                >
                  {" "}
                  <span class="material-icons ">edit</span>
                  <a href="javascript:void(0)">Edit Event</a>
                </button>
              )} */}
          {/* {types != "1" && (
              <button
                type="button"
                className="EditEventButtons"
                onClick={fdata.teams_url !== null ? handleMeeting : ""}
                disabled={fdata.teams_url !== null ? false : true}
              >
                {" "}
                <span class="material-icons me-2">event_available</span>{" "}
                <a href="javascript:void(0)">
                  {types === "1" ? "View Test" : "Join Event"}
                </a>
              </button>
            )} */}
          {/* </div> */}


          {/* class Detsils */}
          <fieldset className="mt-3">
            <legend className="w-auto">
              {types == 1 ? "Test Details" : "Class Details  "}

            </legend>
            <div className="row mb-3">
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">   {types == 1 ? "Test Name" : "Class Name"}</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {fdata.title !== null ? fdata.title : "_"}
                  </p>
                </div>
              </div>

              {/* <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">   Test Number</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {fdata.test_num !== null ? fdata.test_num : "_"}
                  </p>
                </div>
              </div> */}
              {types === "1" && (
                <div className="my-1 col-lg-3 col-md-3 col-12">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0"> Test Topic</p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {" "}
                      {fdata.test_topic !== null ? fdata.test_topic : "_"}
                    </p>
                  </div>
                </div>
              )}
              {types === 1 && (
                <div className="my-1 col-lg-3 col-md-3 col-12">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0"> Total Number of Questions</p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {" "}
                      {fdata.no_ques !== null ? fdata.no_ques : "_"}
                    </p>
                  </div>
                </div>
              )}
              {types === 1 && (
                <div className="my-1 col-lg-3 col-md-3 col-12">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0">    Total Marks</p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {" "}
                      {fdata.tol_mark !== null ? fdata.tol_mark : "_"}
                    </p>
                  </div>
                </div>
              )}
              {/* tag Line */}
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Batch Name</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {fdata.batchName !== null ? fdata.batchName : "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Category</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {fdata.category !== null ? fdata.category : "⎯"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Course</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {fdata.course !== null ? fdata.course : "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">  Class Mode</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {fdata.classMode !== null ? fdata.classMode : "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Medium</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {fdata.medium !== null ? fdata.medium : "⎯"}
                  </p>
                </div>
              </div>
              {fdata.classMode !== "Online" && (
                <div className="my-1 col-lg-3 col-md-3 col-12">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0"> Location</p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {" "}
                      {fdata.location !== null && fdata.location !== ""
                        ? fdata.location
                        : "_"}
                    </p>
                  </div>
                </div>
              )}
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Date</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {fdata.sDate !== null ? fdata.sDate : "⎯"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Start Time</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {fdata.startTime !== null
                      ? moment(fdata.startTime, "HH:mm:ss").format("h:mm A")
                      : "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">  End Time</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {fdata.endTime !== null
                      ? moment(fdata.endTime, "HH:mm:ss").format("h:mm A")
                      : "_"}
                  </p>
                </div>
              </div>
              {types == "1" && (
                <div className="my-1 col-lg-3 col-md-3 col-12">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0"> Method of Test</p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {" "}
                      {fdata.method_of_test !== null
                        ? fdata.method_of_test === 1
                          ? "Descriptive"
                          : "Objective"
                        : "_"}
                    </p>
                  </div>
                </div>
              )}
              {/* {types !== "1" && (
                <div className="my-1 col-lg-3 col-md-3 col-12">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0"> Subject</p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {" "}
                      {fdata.subject ?? "_"}
                    </p>
                  </div>
                </div>
              )} */}
              {types !== "1" && (
                <div className="my-1 col-lg-3 col-md-3 col-12">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0">  Faculty Name</p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {" "}
                      {fdata.staff_name !== null ? fdata.staff_name : "⎯"}
                    </p>
                  </div>
                </div>
              )}
              {types != "1" && (
                <div className="my-1  col-md-12 ">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0">  Instruction to Student</p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {" "}
                      {fdata.description !== null ? fdata.description : "⎯"}
                    </p>
                  </div>
                </div>
              )}
              {types != "1" && (
                <div className="my-1  col-md-12 ">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0">   Instruction to faculty</p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {" "}
                      {fdata.staff_dec !== null ? fdata.staff_dec : "_"}
                    </p>
                  </div>
                </div>
              )}
              {types == "1" && (
                <div className="my-1 col-lg-3 col-md-3 col-12">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0">  Cut Off</p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {" "}
                      {fdata.cut_off !== null ? fdata.cut_off : "⎯"}
                    </p>
                  </div>
                </div>
              )}
              {types == "1" && (
                <>
                  <div className="my-1 col-lg-3 col-md-3 col-12">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0 p-0"> Status</p>
                      <p className="confirm_value my-1 m-0 p-0">
                        {" "}
                        {fdata.que_status === 0 &&
                          "Questions Not Yet Uploaded"}
                        {fdata.que_status === 1 && "Questions Uploaded"}
                        {fdata.que_status === 2 &&
                          (isAfterEndTimeONEHOUR === true
                            ? "Answer Sheet Uploaded"
                            : "Questions Uploaded")}
                        {fdata.que_status === 3 && "Assigned to Evaluators"}
                        {fdata.que_status === 4 && "Answer Sheet Evaluated"}
                        {fdata.que_status === 5 && "Results Published"}
                      </p>
                    </div>
                  </div>
                  <div className="my-1  col-md-12 ">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0 p-0">  Instruction to Student</p>
                      <p className="confirm_value my-1 m-0 p-0">
                        {" "}
                        {fdata.description !== null
                          ? fdata.description
                          : "⎯"}
                      </p>
                    </div>
                  </div>
                  <div className="my-1  col-md-12 ">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0 p-0">    Instruction to Faculty</p>
                      <p className="confirm_value my-1 m-0 p-0">
                        {" "}
                        {fdata.staff_dec !== null &&
                          fdata.staff_dec !== ""
                          ? fdata.staff_dec
                          : "⎯"}
                      </p>
                    </div>
                  </div>
                </>
              )}
            </div>
          </fieldset>
          {/* <div className="row box">
            <div className="col-md-12">
              <p className="StepTitle">
                {" "}
                {types == 1 ? "Test Details" : "Class Details  "}
              </p>
              <div className="row mb-3">
                <div className="col-md-3">
                  <div className="forms ">
                    <label
                      htmlFor="inputName"
                      className="form-label text-muted "
                    >
                      {types == 1 ? "Test Name" : "Class Name"}
                    </label>
                    <span className="ReviewLabel">
                      {fdata.title !== null ? fdata.title : "⎯"}
                    </span>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="forms ">
                    <label
                      htmlFor="inputName"
                      className="form-label text-muted "
                    >
                      Test Number
                    </label>
                    <span className="ReviewLabel">
                      {fdata.test_num !== null ? fdata.test_num : "⎯"}
                    </span>
                  </div>
                </div>
                {types === "1" && (
                  <div className="col-md-3">
                    <div className="forms ">
                      <label
                        htmlFor="inputName"
                        className="form-label text-muted "
                      >
                        Test Topic
                      </label>
                      <span className="ReviewLabel">
                        {fdata.test_topic !== null ? fdata.test_topic : "⎯"}
                      </span>
                    </div>
                  </div>
                )}
                {types === 1 && (
                  <div className="col-md-3">
                    <div className="forms ">
                      <label
                        htmlFor="inputName"
                        className="form-label text-muted "
                      >
                        Total Number of Questions
                      </label>
                      <span className="ReviewLabel">
                        {fdata.no_ques !== null ? fdata.no_ques : "⎯"}
                      </span>
                    </div>
                  </div>
                )}
                {types === 1 && (
                  <div className="col-md-3">
                    <div className="forms ">
                      <label
                        htmlFor="inputName"
                        className="form-label text-muted "
                      >
                        Total Marks
                      </label>
                      <span className="ReviewLabel">
                        {fdata.tol_mark !== null ? fdata.tol_mark : "⎯"}
                      </span>
                    </div>
                  </div>
                )}
                <div className="col-md-3">
                  <div className="forms ">
                    <label
                      htmlFor="inputName"
                      className="form-label text-muted "
                    >
                      Batch Name
                    </label>
                    <span className="ReviewLabel">
                      {fdata.batchName !== null ? fdata.batchName : "⎯"}
                    </span>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="forms ">
                    <label
                      htmlFor="inputName"
                      className="form-label text-muted "
                    >
                      Category
                    </label>
                    <span className="ReviewLabel">
                      {fdata.category !== null ? fdata.category : "⎯"}
                    </span>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="forms ">
                    <label
                      htmlFor="inputName"
                      className="form-label text-muted "
                    >
                      Course
                    </label>
                    <span className="ReviewLabel">
                      {fdata.course !== null ? fdata.course : "⎯"}
                    </span>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="forms ">
                    <label
                      htmlFor="inputName"
                      className="form-label text-muted "
                    >
                      Class Mode
                    </label>
                    <span className="ReviewLabel">
                      {fdata.classMode !== null ? fdata.classMode : "⎯"}
                    </span>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="forms ">
                    <label
                      htmlFor="inputName"
                      className="form-label text-muted "
                    >
                      Medium
                    </label>
                    <span className="ReviewLabel">
                      {fdata.medium !== null ? fdata.medium : "⎯"}
                    </span>
                  </div>
                </div>
                {fdata.classMode !== "Online" && (
                  <div className="col-md-3">
                    <div className="forms ">
                      <label
                        htmlFor="inputName"
                        className="form-label text-muted"
                      >
                        Location
                      </label>
                      <span className="ReviewLabel">
                        {fdata.location !== null && fdata.location !== ""
                          ? fdata.location
                          : "⎯"}
                      </span>
                    </div>
                  </div>
                )}
                <div className="col-md-3">
                  <div className="forms ">
                    <label
                      htmlFor="inputName"
                      className="form-label text-muted "
                    >
                      Date
                    </label>
                    <span className="ReviewLabel">
                      {fdata.sDate !== null ? fdata.sDate : "⎯"}
                    </span>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="forms ">
                    <label
                      htmlFor="inputName"
                      className="form-label text-muted "
                    >
                      Start Time
                    </label>
                    <span className="ReviewLabel">
                      {fdata.startTime !== null
                        ? moment(fdata.startTime, "HH:mm:ss").format("h:mm A")
                        : "⎯"}
                    </span>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="forms ">
                    <label
                      htmlFor="inputName"
                      className="form-label text-muted "
                    >
                      End Time
                    </label>
                    <span className="ReviewLabel">
                      {fdata.endTime !== null
                        ? moment(fdata.endTime, "HH:mm:ss").format("h:mm A")
                        : "⎯"}
                    </span>
                  </div>
                </div>
                {types == "1" && (
                  <div className="col-md-3">
                    <div className="forms ">
                      <label
                        htmlFor="inputName"
                        className="form-label text-muted "
                      >
                        Method of Test
                      </label>
                      <span className="ReviewLabel">
                        {fdata.method_of_test !== null
                          ? fdata.method_of_test === 1
                            ? "Descriptive"
                            : "Objective"
                          : "⎯"}
                      </span>
                    </div>
                  </div>
                )}
                {types !== "1" && (
                  <div className="col-md-3">
                    <div className="forms ">
                      <label
                        htmlFor="inputName"
                        className="form-label text-muted "
                      >
                        Subject
                      </label>
                      <span className="ReviewLabel">
                        {fdata.subject ?? "⎯"}
                      </span>
                    </div>
                  </div>
                )}{" "}
                {types != "1" && (
                  <div className="col-md-3">
                    <div className="forms ">
                      <label
                        htmlFor="inputName"
                        className="form-label text-muted "
                      >
                        Faculty Name
                      </label>
                      <span className="ReviewLabel">
                        {fdata.staff_name !== null ? fdata.staff_name : "⎯"}
                      </span>
                    </div>
                  </div>
                )}{" "}
                {types != "1" && (
                  <div className="col-md-12">
                    <div className="forms ">
                      <label
                        htmlFor="inputName"
                        className="form-label text-muted "
                      >
                        Instruction to Student
                      </label>
                      <span className="ReviewLabel">
                        {fdata.description !== null ? fdata.description : "⎯"}
                      </span>
                    </div>
                  </div>
                )}{" "}
                {types != "1" && (
                  <div className="col-md-3">
                    <div className="forms ">
                      <label
                        htmlFor="inputName"
                        className="form-label text-muted "
                      >
                        Instruction to faculty
                      </label>
                      <span className="ReviewLabel">
                        {fdata.staff_dec !== null ? fdata.staff_dec : "⎯"}
                      </span>
                    </div>
                  </div>
                )}{" "}
                {types == "1" && (
                  <>
                    <div className="col-lg-3 col-md-4">
                      <div className="forms ">
                        <label
                          htmlFor="inputName"
                          className={`form-label  text-muted`}
                        >
                          Status
                        </label>
                        <span className="ReviewLabel">
                          {fdata.que_status === 0 &&
                            "Questions Not Yet Uploaded"}
                          {fdata.que_status === 1 && "Questions Uploaded"}
                          {fdata.que_status === 2 &&
                            (isAfterEndTimeONEHOUR === true
                              ? "Answer Sheet Uploaded"
                              : "Questions Uploaded")}
                          {fdata.que_status === 3 && "Assigned to Evaluators"}
                          {fdata.que_status === 4 && "Answer Sheet Evaluated"}
                          {fdata.que_status === 5 && "Results Published"}
                        </span>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="forms ">
                        <label
                          htmlFor="inputName"
                          className="form-label text-muted "
                        >
                          Instruction to Student
                        </label>
                        <span className="ReviewLabel">
                          {fdata.description !== null
                            ? fdata.description
                            : "⎯"}
                        </span>
                      </div>
                    </div>
                    {types != "1" && (
                      <div className="col-md-12">
                        <div className="forms ">
                          <label
                            htmlFor="inputName"
                            className="form-label text-muted "
                          >
                            Instruction to Faculty
                          </label>
                          <span className="ReviewLabel">
                            {fdata.staff_dec !== null &&
                              fdata.staff_dec !== ""
                              ? fdata.staff_dec
                              : "⎯"}
                          </span>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div> */}
          {/* </section> */}
          {(types === 1 || types === 0) && (
            <fieldset className="mt-3">
              <legend className="w-auto">
                Subjects and Topics
              </legend>
              <div className="row mb-3">
                <div className="my-1  col-md-12 ">
                  <div className="d-flex flex-column">
                    <div className="d-flex">
                      <p className="confirm_label m-0 p-0">
                        Uploaded Syllabus{" "}
                      </p>{" "}
                      {fdata.syllabus_path !== "" &&
                        fdata.syllabus_path !== null && (
                          <>
                            <a
                              to="javascript:void(0)"
                              onClick={() =>
                                handleDownloadSyllabus(fdata.syllabus_path)
                              }
                              download
                            >
                              <span className="material-icons align-middle download_icon">
                                file_download
                              </span>
                            </a>
                          </>
                        )}
                    </div>

                    <p className="confirm_value my-1 m-0 p-0">
                      {fdata.syllabus_path || "_"}
                    </p>
                  </div>
                </div>
                {subTopic.length > 0 ? (
                  subTopic.map((onk) => {
                    return (
                      <>
                        <div className="my-1 col-lg-3 col-md-3 col-12">
                          <div className="d-flex flex-column">
                            <p className="confirm_label m-0 p-0">  Subject</p>
                            <p className="confirm_value my-1 m-0 p-0">
                              {" "}
                              {onk.subject_name || "-"}
                            </p>
                          </div>
                        </div>
                        <div className="my-1 col-lg-3 col-md-3 col-12">
                          <div className="d-flex flex-column">
                            <p className="confirm_label m-0 p-0">   Test Topics</p>
                            <p className="confirm_value my-1 m-0 p-0">
                              {" "}
                              {onk.test_topics
                                .map((el) => el.test_topic)
                                .join(", ") || "-"}
                            </p>
                          </div>
                        </div>

                      </>
                    );
                  })
                ) : (
                  <>
                    <div className="my-1 col-lg-3 col-md-3 col-12">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0 p-0">  Subject</p>
                        <p className="confirm_value my-1 m-0 p-0">
                          {"-"}
                        </p>
                      </div>
                    </div>
                    <div className="my-1 col-lg-3 col-md-3 col-12">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0 p-0">   Test Topics</p>
                        <p className="confirm_value my-1 m-0 p-0">
                          {"-"}
                        </p>
                      </div>
                    </div>

                  </>
                )}

              </div>
              {/* <section className=" StepOne">
                <div className="row box">
                  <div className="col-md-12 mb-3">
                    <p className="StepTitle">Subjects and Topics</p>
                    <div className="row ">
                      <div className="col-md-3">
                        <div className="forms ">
                          <button
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0px",
                              margin: "0px",
                              textAlign: "start",
                            }}
                            onClick={() =>
                              handleDownloadSyllabus(fdata.syllabus_path)
                            }
                          >
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                              style={{ cursor: "pointer" }}
                            >
                              Uploaded Syllabus{" "}
                              <IconDownload
                                style={{
                                  color: "#C0272D",
                                  marginLeft: "5px",
                                }}
                              />
                            </label>
                          </button>
                          <span className="ReviewLabel">
                            {" "}
                            {fdata.syllabus_path
                              ? fdata.syllabus_path.split("/").pop()
                              : "_"}
                          </span>
                        </div>
                      </div>
                    </div>
                    {subTopic.length > 0 ? (
                      subTopic.map((onk) => {
                        return (
                          <div className="row ">
                            <div className="col-md-4">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted "
                                >
                                  Subject
                                </label>
                                <span className="ReviewLabel">
                                  {onk.subject_name}
                                </span>
                              </div>
                            </div>

                            <div className="col-md-8">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted "
                                >
                                  Test Topics
                                </label>
                                <span className="ReviewLabel">
                                  {onk.test_topics
                                    .map((el) => el.test_topic)
                                    .join(", ")}
                                </span>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="row ">
                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              {" "}
                              _
                            </label>
                            <span className="ReviewLabel">No Records</span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </section> */}
            </fieldset>
          )}
          {/* {(types === 0) && (
            <fieldset className="mt-3">
              <legend className="w-auto">
                Recording URL and Attendance Sheet
              </legend>
              <div className="row mb-3">

                <div className="my-1 col-lg-3 col-md-3 col-12">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0">   Recording URL</p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {" "}
                      {fdata.recording_url || "_"}
                    </p>
                  </div>
                </div>
                <div className="my-1 col-lg-3 col-md-3 col-12">
                  <div className="d-flex flex-column">
                    <div className="d-flex">
                      <p className="confirm_label m-0 p-0">
                        {" "}
                        Attendance Sheet
                      </p>{" "}
                     
                    </div>

                    <p className="confirm_value my-1 m-0 p-0">
                      {fdata.original_attendancesheet_file_path || "_"}
                    </p>
                  </div>
                </div>
              </div>
            </fieldset>
          )} */}
          {(types === 1 || types === 0) && (
            <fieldset className="mt-3">
              <legend className="w-auto">
                Other Applicable Batches
              </legend>
              <div className="row mb-3">
                <div className="my-1 col-lg-3 col-md-3 col-12">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0">  Other Applicable Batches</p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {oth_app_batch.length > 0 ? (
                        <>
                          {oth_app_batch.map((lk, index) => (
                            <React.Fragment key={index}>
                              {index > 0 && ", "}{" "}
                              {/* Add comma and space for elements after the first one */}
                              {lk.name}({lk.section})
                            </React.Fragment>
                          ))}
                        </>


                      ) : (
                        <p className="confirm_value my-1 m-0 p-0">
                          _
                        </p>
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </fieldset>
          )}
          {/* <div className="row mx-0 mt-3 mb-4">
            <div className="col-xl-12 col-lg-12 col-md-12 col-12 px-0">
              <fieldset className={ViewBookSet.preorderContainer}>
                <legend className="w-auto mb-0">Class Attendance</legend>
                <div className="row mx-0 ">
                  <div className="col-lg-4 col-md-4 mb-3 col-sm-12 col-xs-12 px-0">
                    <div class={ViewBookSet.searchInputSec}>
                      <input
                        className={`${ViewBookSet.searchInput} w-100`}
                        type="text"
                        placeholder="Search by Student Name, Email, Phone Number"
                        name="search_book_title"
                        onKeyDown={handleSearch}
                        ref={txtBSearch}
                      />
                      <Search
                        onClick={handleSearchFocus}
                        className={`${ViewBookSet.ListsearchIcon}`}
                      />
                    </div>
                  </div>

                  <div className="col-md-8 col-12 ListBtn px-0">
                    <ul class="List-Button">
                      <li class="ListBtnItems">
                        <CustomDownloadButton
                          csvListData={updateListData?.length > 0 ? updateListData : ""}
                          iconName=" file_download "
                          filename={"IndiviualsBook.csv"}
                          csvName="  Download as CSV"
                        />
                      </li>
                      <li class="ListBtnItems primaryButton" onClick={generatePDF}>
                        <span className="material-icons me-1 align-middle text-white">
                          file_download
                        </span>
                        Download as PDF
                      </li>
                    </ul>
                  </div>
                </div>
                {updateChipData?.length > 0 ? (
                  <div className="row mt-3">
                    <div className="col-md-12 col-sm-12 col-xs-12 paperil_global">
                      <Paper
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          flexWrap: "wrap",
                          listStyle: "none",
                          p: 0.5,
                          m: 0,
                        }}
                        component="ul"
                      >
                        {updateChipData.map((data, index) => {
                          let icon;
                          let key = "" + data.name;
                          return (
                         



                            <ListItem key={data}>
                              <Chip
                                icon={icon}
                                label={key}
                                onDelete={handleDelete(data, index)}
                              />
                            </ListItem>
                          );
                        })}
                        <ListItem className="clearAll_list">
                          <a
                            className="clearAll_listItem"
                            href="javascript:void(0)"
                            onClick={handleAllClear}
                          >
                            Clear All Filters
                          </a>
                        </ListItem>
                      </Paper>
                    </div>
                  </div>
                ) : (
                  <div></div>
                )}
                <div className="row mx-0 mt-2">
                  <div
                    className={`col-md-12 ${ViewBookSet.table_responsive_padding} table-responsive tableMinHeight px-0 `}
                  >

                    <table className="table" id="tableListHeader">
                      <thead>
                        <tr>
                          <th id="th" className={ViewBookSet.tableThPadding}>
                            <span
                              onClick={(e) => handleSort(e, "serialNumber")}
                              className="textHead_th"
                            >
                              S.No.
                            </span>
                            <span
                              onClick={(e) => handleSort(e, "serialNumber")}
                              className={`textHead_th material-icons align-middle`}
                            >
                              import_export{" "}
                            </span>
                          </th>
                          <th id="th" className={ViewBookSet.tableThPadding}>
                            <span
                              onClick={(e) => handleSort(e, "name")}
                              className="textHead_th"
                            >
                              Student Name
                            </span>
                            <span
                              onClick={(e) => handleSort(e, "name")}
                              className={`textHead_th material-icons align-middle`}
                            >
                              import_export{" "}
                            </span>
                          </th>

                          <th id="th" className={ViewBookSet.tableThPadding}>
                            <span
                              onClick={(e) => handleSort(e, "email")}
                              className="textHead_th"
                            >
                              Email
                            </span>
                            <span
                              onClick={(e) => handleSort(e, "email")}
                              className={`textHead_th material-icons align-middle`}
                            >
                              import_export{" "}
                            </span>
                          </th>
                          <th id="th" className={ViewBookSet.tableThPadding}>
                            <span
                              onClick={(e) => handleSort(e, "phone_no")}
                              className="textHead_th"
                            >
                              Phone Number
                            </span>
                            <span
                              onClick={(e) => handleSort(e, "phone_no")}
                              className={`textHead_th material-icons align-middle`}
                            >
                              import_export{" "}
                            </span>
                          </th>
                          <th id="th" className={ViewBookSet.tableThPadding} ref={filterRef_batch_name}>
                            <span
                              onClick={(e) => handleSort(e, "batch_name")}
                              className="textHead_th"
                            >
                              Batch Name
                            </span>
                            <span
                              onClick={(e) => handleSort(e, "batch_name")}
                              className={`textHead_th material-icons align-middle`}
                            >
                              import_export{" "}
                            </span>
                            <span
                              className={`textHead_th align-middle material-icons ${batch_name.length > 0
                                ? ViewBookSet.active_icons_book
                                : ""
                                } ${isOpen.batch_name ? ViewBookSet.active_icons_book : ""
                                }`} 
                              onClick={(e) => handleFilter(e, "batch_name")}
                            >
                              filter_list
                            </span>
                            {isOpen.batch_name && (
                              <>
                                <div className="filterBoxs_testlist mt-3">
                                  <div className="col-md-12 form-check filterStatus_list">
                                    <ul className="ulFilterListData">
                                      <li
                                        className={`filterListData ${ViewBookSet.searchInputSec}`}>
                                        <input
                                          className={`${ViewBookSet.searchInput} w-100`}
                                          type="text"
                                          placeholder="Search by batch name"
                                          name="search_batch_name"
                                          onChange={(e) =>
                                            handleFilterCourseSearch(e, "batch_name")
                                          }
                                          ref={txtBSearch_batch_name}
                                        />
                                        <Search
                                          onClick={() =>
                                            handleFilterSearchFocus("batch_name")
                                          }
                                          className={`${ViewBookSet.ListsearchIcon}`}
                                        />
                                      </li>
                                      {batchList.map((el) => (
                                        <>

                                          <li className="filterListData">

                                            <input
                                              className="ListCheckbox"
                                              type="checkbox"
                                              name={el.batch_name}
                                              value={el.batch_id}
                                              id={el.batch_name}
                                              checked={batch_name.some((element) => {
                                                if (element.name == el.batch_name) {
                                                  return true;
                                                }
                                                return false;
                                              })}
                                              onChange={(e) =>
                                                handleCheckboxChange(e, el.batch_name, "batch_name")
                                              }
                                            />
                                            <label
                                              className="form-check-label filterChipText_withoutBG "
                                              htmlFor={el.batch_name}
                                            >
                                              {el.batch_name}
                                            </label>
                                          </li>
                                        </>



                                      ))}
                                    </ul>
                                  </div>
                                  <div className="borderWidth row">
                                    <ul className="List-Button">
                                      <Link
                                        to={"javascript:void(0)"}
                                        onClick={() => handleClear("batch_name")}
                                        className="secondaryButton "
                                      >
                                        Clear
                                      </Link>
                                      <li className="ListBtnItems">
                                        <Link
                                      
                                          to={"javascript:void(0)"}
                                          onClick={() =>
                                            handleApplyFilter("batch_name")
                                          }
                                          className="primaryButton"
                                        >
                                          Apply Filter
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </div>

                              </>
                            )}
                          </th>
                          <th id="th" className={ViewBookSet.tableThPadding} ref={filterRef_section}>
                            <span
                              onClick={(e) => handleSort(e, "section")}
                              className="textHead_th"
                            >
                              Section
                            </span>
                            <span
                              onClick={(e) => handleSort(e, "section")}
                              className={`textHead_th material-icons align-middle`}
                            >
                              import_export{" "}
                            </span>
                            <span
                              className={`textHead_th align-middle material-icons ${section.length > 0
                                ? ViewBookSet.active_icons_book
                                : ""
                                } ${isOpen.section ? ViewBookSet.active_icons_book : ""
                                }`} 
                              onClick={(e) => handleFilter(e, "section")}
                            >
                              filter_list
                            </span>

                            {isOpen.section && (
                              <>
                                <div className="filterBoxs_testlist mt-3">
                                  <div className="col-md-12 form-check filterStatus_list">
                                    <ul className="ulFilterListData">
                                      {sectionList.map((el) => (
                                        <li className="filterListData">
                                          <input
                                            className="ListCheckbox"
                                            type="checkbox"
                                            name={el.section}
                                            value={el.id}
                                            id={el.section}
                                            checked={section.some((element) => {
                                              if (element.name == el.section) {
                                                return true;
                                              }
                                              return false;
                                            })}
                                            onChange={(e) =>
                                              handleCheckboxChange(e, el.section, "section")
                                            }
                                          />
                                          <label
                                            className="form-check-label filterChipText_withoutBG "
                                            htmlFor={el.section}
                                          >
                                            {el.section}
                                          </label>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                  <div className="borderWidth row">
                                    <ul className="List-Button">
                                      <Link
                                        to={"javascript:void(0)"}
                                        onClick={() => handleClear("section")}
                                        className="secondaryButton "
                                      >
                                        Clear
                                      </Link>
                                      <li className="ListBtnItems">
                                        <Link
                                          to={"javascript:void(0)"}
                                          onClick={() =>
                                            handleApplyFilter("section")
                                          }
                                          className="primaryButton"
                                        >
                                          Apply Filter
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </div>

                              </>
                            )}
                          </th>
                          <th id="th" className={ViewBookSet.tableThPadding} ref={filterRef_medium}>
                            <span
                              onClick={(e) => handleSort(e, "medium")}
                              className="textHead_th"
                            >
                              Medium
                            </span>
                            <span
                              onClick={(e) => handleSort(e, "medium")}
                              className={`textHead_th material-icons align-middle`}
                            >
                              import_export{" "}
                            </span>
                            <span
                              className={`textHead_th align-middle material-icons ${medium.length > 0
                                ? ViewBookSet.active_icons_book
                                : ""
                                } ${isOpen.course ? ViewBookSet.active_icons_book : ""
                                }`} // Change here
                              onClick={(e) => handleFilter(e, "medium")}
                            >
                              filter_list
                            </span>
                            {isOpen.medium && (
                              <>
                                <div className="filterBoxs_testlist mt-3">
                                  <div className="col-md-12 form-check filterStatus_list">
                                    <ul className="ulFilterListData">
                                      <li className="filterListData">
                                        <input
                                          className="ListCheckbox"
                                          type="checkbox"
                                          name={"Tamil"}
                                          value={"0"}
                                          checked={medium_on.some((element) => {
                                            if (element.id == "0") {
                                              return true;
                                            }
                                            return false;
                                          })}
                                          id={"Tamil"}
                                          onChange={(e) =>
                                            handleCheckboxChange(e, "medium", "medium")
                                          }
                                        />
                                        <label
                                          className="form-check-label filterChipText_withoutBG "
                                          htmlFor={"Tamil"}
                                        >
                                          Tamil
                                        </label>
                                      </li>
                                      <li className="filterListData">
                                        <input
                                          className="ListCheckbox"
                                          type="checkbox"
                                          name={"English"}
                                          value={"1"}
                                          checked={medium_on.some((element) => {
                                            if (element.id == "1") {
                                              return true;
                                            }
                                            return false;
                                          })}
                                          id={"English"}
                                          onChange={(e) =>
                                            handleCheckboxChange(e, "medium", "medium")
                                          }
                                        />
                                        <label
                                          className="form-check-label filterChipText_withoutBG "
                                          htmlFor={"English"}
                                        >
                                          English
                                        </label>
                                      </li>
                                   
                                    </ul>
                                  </div>
                                  <div className="borderWidth row">
                                    <ul className="List-Button">
                                      <li className="ListBtnItems">
                                        <Link
                                          to={"javascript:void(0)"}
                                          onClick={() => handleClear("medium")}
                                          className="secondaryButton "
                                        >
                                          Clear
                                        </Link>
                                      </li>
                                      <li className="ListBtnItems">
                                        <Link
                                          disabled={medium_on.length === 0 ? true : false}
                                          to={"javascript:void(0)"}
                                          onClick={() => handleApplyFilter("medium")}
                                          className="primaryButton"
                                        >
                                          Apply Filter
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </>
                            )}
                          </th>
                          <th id="th" className={ViewBookSet.tableThPadding} ref={filterRef_class_mode}>
                            <span
                              onClick={(e) => handleSort(e, "class_mode")}
                              className="textHead_th"
                            >
                              Class Mode
                            </span>
                            <span
                              onClick={(e) => handleSort(e, "class_mode")}
                              className={`textHead_th material-icons align-middle`}
                            >
                              import_export{" "}
                            </span>
                            <span
                              className={`textHead_th align-middle material-icons ${classMode.length > 0
                                ? ViewBookSet.active_icons_book
                                : ""
                                } ${isOpen.class_mode ? ViewBookSet.active_icons_book : ""
                                }`} 
                              onClick={(e) => handleFilter(e, "class_mode")}
                            >
                              filter_list
                            </span>
                            {isOpen.class_mode && (
                              <>
                                <div className="filterBoxs_testlist mt-3">
                                  <div className="col-md-12 form-check filterStatus_list">
                                    <ul className="ulFilterListData">
                                      <li className="filterListData">
                                        <input
                                          className="ListCheckbox"
                                          type="checkbox"
                                          name={"Online"}
                                          value={"0"}
                                          checked={classMode.some((element) => {
                                            if (element.id == "0") {
                                              return true;
                                            }
                                            return false;
                                          })}
                                          id={"Online"}
                                          onChange={(e) =>
                                            handleCheckboxChange(e, "class_mode", "class_mode")
                                          }
                                        />
                                        <label
                                          className="form-check-label filterChipText_withoutBG "
                                          htmlFor={"Online"}
                                        >
                                          Online
                                        </label>
                                      </li>
                                      <li className="filterListData">
                                        <input
                                          className="ListCheckbox"
                                          type="checkbox"
                                          name={"Classroom"}
                                          value={"1"}
                                          checked={classMode.some((element) => {
                                            if (element.id == "1") {
                                              return true;
                                            }
                                            return false;
                                          })}
                                          id={"Classroom"}
                                          onChange={(e) =>
                                            handleCheckboxChange(e, "class_mode", "class_mode")
                                          }
                                        />
                                        <label
                                          className="form-check-label filterChipText_withoutBG "
                                          htmlFor={"Classroom"}
                                        >
                                          Classroom
                                        </label>
                                      </li>


                                    </ul>
                                  </div>
                                  <div className="borderWidth row">
                                    <ul className="List-Button">
                                      <li className="ListBtnItems">
                                        <Link
                                          to={"javascript:void(0)"}
                                          onClick={() => handleClear("class_mode")}
                                          className="secondaryButton "
                                        >
                                          Clear
                                        </Link>
                                      </li>
                                      <li className="ListBtnItems">
                                        <Link
                                          disabled={classMode.length === 0 ? true : false}
                                          to={"javascript:void(0)"}
                                          onClick={() => handleApplyFilter("class_mode")}
                                          className="primaryButton"
                                        >
                                          Apply Filter
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </>
                            )}
                          </th>
                          <th id="th" className={ViewBookSet.tableThPadding} ref={filterRef_schedule}>
                            <span
                              onClick={(e) => handleSort(e, "schedule")}
                              className="textHead_th"
                            >
                              Schedule Preference
                            </span>
                            <span
                              onClick={(e) => handleSort(e, "schedule")}
                              className={`textHead_th material-icons align-middle`}
                            >
                              import_export{" "}
                            </span>
                            <span
                              className={`textHead_th align-middle material-icons ${schedule.length > 0
                                ? ViewBookSet.active_icons_book
                                : ""
                                } ${isOpen.schedule ? ViewBookSet.active_icons_book : ""
                                }`}
                              onClick={(e) => handleFilter(e, "schedule")}
                            >
                              filter_list
                            </span>
                            {isOpen.schedule && (
                              <>
                                <div className="filterBoxs_testlist mt-3">
                                  <div className="col-md-12 form-check filterStatus_list">
                                    <ul className="ulFilterListData">
                                      <li className="filterListData">
                                        <input
                                          className="ListCheckbox"
                                          type="checkbox"
                                          name={"Weekend"}
                                          value={"0"}
                                          checked={schedule.some((element) => {
                                            if (element.id == "0") {
                                              return true;
                                            }
                                            return false;
                                          })}
                                          id={"Weekend"}
                                          onChange={(e) =>
                                            handleCheckboxChange(e, "schedule", "schedule")
                                          }
                                        />
                                        <label
                                          className="form-check-label filterChipText_withoutBG "
                                          htmlFor={"Weekend"}
                                        >
                                          Weekend
                                        </label>
                                      </li>
                                      <li className="filterListData">
                                        <input
                                          className="ListCheckbox"
                                          type="checkbox"
                                          name={"Regular"}
                                          value={"1"}
                                          checked={schedule.some((element) => {
                                            if (element.id == "1") {
                                              return true;
                                            }
                                            return false;
                                          })}
                                          id={"Regular"}
                                          onChange={(e) =>
                                            handleCheckboxChange(e, "schedule", "schedule")
                                          }
                                        />
                                        <label
                                          className="form-check-label filterChipText_withoutBG "
                                          htmlFor={"Regular"}
                                        >
                                          Regular
                                        </label>
                                      </li>


                                    </ul>
                                  </div>
                                  <div className="borderWidth row">
                                    <ul className="List-Button">
                                      <li className="ListBtnItems">
                                        <Link
                                          to={"javascript:void(0)"}
                                          onClick={() => handleClear("schedule")}
                                          className="secondaryButton "
                                        >
                                          Clear
                                        </Link>
                                      </li>
                                      <li className="ListBtnItems">
                                        <Link
                                          disabled={schedule.length === 0 ? true : false}
                                          to={"javascript:void(0)"}
                                          onClick={() => handleApplyFilter("schedule")}
                                          className="primaryButton"
                                        >
                                          Apply Filter
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </>
                            )}
                          </th>
                          <th id="th" className={ViewBookSet.tableThPadding} ref={filterRef_location}>
                            <span
                              onClick={(e) => handleSort(e, "location")}
                              className="textHead_th"
                            >
                              Location
                            </span>
                            <span
                              onClick={(e) => handleSort(e, "location")}
                              className={`textHead_th material-icons align-middle`}
                            >
                              import_export{" "}
                            </span>
                            <span
                              className={`textHead_th align-middle material-icons ${locations.length > 0
                                ? ViewBookSet.active_icons_book
                                : ""
                                } ${isOpen.location
                                  ? ViewBookSet.active_icons_book
                                  : ""
                                }`} 
                              onClick={(e) => handleFilter(e, "location")}
                            >
                              filter_list
                            </span>
                            {isOpen.location && (
                              <>
                                <div className="filterBoxs_testlist mt-3">
                                  <div className="col-md-12 form-check filterStatus_list">
                                    <ul className="ulFilterListData">
                                      {locationsId.map((el) => (
                                        <li className="filterListData">
                                          <input
                                            className="ListCheckbox"
                                            type="checkbox"
                                            name={el.name}
                                            value={el.id}
                                            id={el.name}
                                            checked={locations.some(
                                              (element) => {
                                                if (element.id == el.id) {
                                                  return true;
                                                }
                                                return false;
                                              }
                                            )}
                                            onChange={(e) =>
                                              handleCheckboxChange(
                                                e,
                                                el.name,
                                                "location"
                                              )
                                            }
                                          />
                                          <label
                                            className="form-check-label filterChipText_withoutBG "
                                            htmlFor={el.name}
                                          >
                                            {el.name}
                                          </label>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                  <div className="borderWidth row">
                                    <ul className="List-Button">
                                      <li className="ListBtnItems">
                                        <Link
                                          to={"javascript:void(0)"}
                                          onClick={() => handleClear("location")}
                                          className="secondaryButton "
                                        >
                                          Clear
                                        </Link>
                                      </li>
                                      <li className="ListBtnItems">
                                        <Link
                                          disabled={
                                            locations.length === 0
                                              ? true
                                              : false
                                          }
                                          to={"javascript:void(0)"}
                                          onClick={() =>
                                            handleApplyFilter("location")
                                          }
                                          className="primaryButton"
                                        >
                                          Apply Filter
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </div>

                              </>
                            )}
                          </th>
                          <th id="th" className={ViewBookSet.tableThPadding}  ref={filterRef_status}>
                            <span
                              onClick={(e) => handleSort(e, "medium")}
                              className="textHead_th"
                            >
                              Status
                            </span>
                            <span
                              onClick={(e) => handleSort(e, "medium")}
                              className={`textHead_th material-icons align-middle`}
                            >
                              import_export{" "}
                            </span>
                            <span
                              className={`textHead_th align-middle material-icons ${status.length > 0
                                ? ViewBookSet.active_icons_book
                                : ""
                                } ${isOpen.status ? ViewBookSet.active_icons_book : ""
                                }`} // Change here
                              onClick={(e) => handleFilter(e, "status")}
                            >
                              filter_list
                            </span>
                            {isOpen.status && (
                              <>
                                <div className="filterBoxs_testlist mt-3">
                                  <div className="col-md-12 form-check filterStatus_list">
                                    <ul className="ulFilterListData">
                                      <li className="filterListData">
                                        <input
                                          className="ListCheckbox"
                                          type="checkbox"
                                          name={"Present"}
                                          value={1}
                                          checked={status.some((element) => {
                                            if (element.id == 1) {
                                              return true;
                                            }
                                            return false;
                                          })}
                                          id={"Present"}
                                          onChange={(e) =>
                                            handleCheckboxChange(e, "status", "status")
                                          }
                                        />
                                        <label
                                          className="form-check-label filterChipText_withoutBG "
                                          htmlFor={"Present"}
                                        >
                                          Present
                                        </label>
                                      </li>
                                      <li className="filterListData">
                                        <input
                                          className="ListCheckbox"
                                          type="checkbox"
                                          name={"Absent"}
                                          value={0}
                                          checked={status.some((element) => {
                                            if (element.id == 0) {
                                              return true;
                                            }
                                            return false;
                                          })}
                                          id={"Absent"}
                                          onChange={(e) =>
                                            handleCheckboxChange(e, "status", "status")
                                          }
                                        />
                                        <label
                                          className="form-check-label filterChipText_withoutBG "
                                          htmlFor={"Absent"}
                                        >
                                          Absent
                                        </label>
                                      </li>
                                    </ul>
                                  </div>
                                  <div className="borderWidth row">
                                    <ul className="List-Button">
                                      <li className="ListBtnItems">
                                        <Link
                                          to={"javascript:void(0)"}
                                          onClick={() => handleClear("status")}
                                          className="secondaryButton "
                                        >
                                          Clear
                                        </Link>
                                      </li>
                                      <li className="ListBtnItems">
                                        <Link
                                          disabled={status.length === 0 ? true : false}
                                          to={"javascript:void(0)"}
                                          onClick={() => handleApplyFilter("status")}
                                          className="primaryButton"
                                        >
                                          Apply Filter
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </>
                            )}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentData?.length === 0 ? (
                          <tr>
                            <td colspan="15" style={{ textAlign: "center" }}>
                              No records to display
                            </td>
                          </tr>
                        ) : (
                          currentData?.map((kl, ind) => (


                            <tr key={ind}>
                              <td id="td">{kl.serialNumber}</td>
                              <td id="td">
                                <span
                                  title={kl.name}
                                  className={ViewBookSet.ellipsisText}
                                >
                                  {kl.name}
                                </span>
                              </td>
                              <td id="td">
                                {" "}
                                <span
                                  title={kl.email}
                                  className={ViewBookSet.ellipsisText}
                                >
                                  {kl.email ? kl.email : "_"}
                                </span>
                              </td>
                              <td id="td">
                                <span
                                  title={kl.phone_no}
                                  className={ViewBookSet.ellipsisText}
                                >
                                  {kl.phone_no ? kl.phone_no : "_"}
                                </span>
                              </td>
                              <td id="td">{kl.batch_name ? kl.batch_name : "_"}</td>
                              <td id="td">
                                {kl.section ? kl.section : "_"}
                              </td>
                              <td id="td">
                                {kl.medium ? kl.medium : "_"}
                              </td>
                              <td id="td">
                                {kl.class_mode ? kl.class_mode : "_"}
                              </td>
                              <td id="td">{kl.batch_type ? kl.batch_type : "_"}</td>
                              <td id="td">{kl.location ? kl.location : "_"}</td>
                              <td id="td">
                                {kl.status == 0 ? "Absent" : "Present"}
                              </td>


                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="row mt-2">
                  <Pagination
                    rowsPerPage={rowsPerPage}
                    handlePageCount={handlePageCount}
                    startPage={
                      updateListData && updateListData?.length > 0
                        ? currentPage * rowsPerPage + 1 - rowsPerPage
                        : 0
                    }
                    endPage={
                      updateListData && updateListData?.length > 0
                        ? updateListData?.length < currentPage * rowsPerPage
                          ? updateListData?.length
                          : currentPage * rowsPerPage
                        : 0
                    }
                    totalRecords={
                      updateListData && updateListData?.length > 0
                        ? updateListData?.length
                        : 0
                    }
                    handlePrev={(e) => handlePrev(currentPage - 1)}
                    currentPrevPage={currentPage === 1}
                    prevButton={`${ViewBookSet.prev_buttonViewAllbook} ${ViewBookSet.materialIconsRightAndLeft} me-2`}
                    handleNext={() => handleNext(currentPage + 1)}
                    currentNextPage={totalPages == 0 || currentPage === totalPages}
                  />
                </div>
              </fieldset>
            </div>
          </div> */}
          {types === 1 && fdata.method_of_test === 1 && (
            <section className="StepOne">
              <div className={` row box`}>
                <div className="col-md-12 pb-2">
                  <p className={`StepTitle`}> Question Paper</p>
                  <div className="row ">
                    {/* 1 */}
                    <div className="col-md-3">
                      <div className={`forms`}>
                        <label
                          htmlFor="inputName"
                          className={`form-label text-muted`}
                        >
                          Question Paper
                          {fdata.qpath !== "" && fdata.qpath !== null && (
                            <>
                              <a
                                href={`${ImageUrlPrefix}/${fdata.qpath}`}
                                target="_blank"
                                download
                              >
                                <span className="material-icons align-middle download_icon">
                                  file_download
                                </span>
                              </a>
                              <a
                                href={`${ImageUrlPrefix}/${fdata.qpath}`}
                                target="_blank"
                                download
                                styles={{ marginTop: "5px" }}
                              >
                                <span className="material-icons align-middle download_icon">
                                  visibility
                                </span>
                              </a>
                            </>
                          )}
                        </label>
                        <span className={`ReviewLabel`}>
                          {fdata.qpath_original_path || "_"}
                        </span>
                      </div>
                    </div>
                    {/* 2 */}
                    <div className="col-md-3">
                      <div className={`forms`}>
                        <label
                          htmlFor="inputName"
                          className={` form-label text-muted`}
                        >
                          Answer Booklet
                          {fdata.answer_booklet_path !== "" &&
                            fdata.answer_booklet_path !== null && (
                              <>
                                <a
                                  href={`${ImageUrlPrefix}/${fdata.answer_booklet_path}`}
                                  target="_blank"
                                  download
                                >
                                  <span className="material-icons align-middle download_icon">
                                    file_download
                                  </span>
                                </a>
                                <a
                                  href={`${ImageUrlPrefix}/${fdata.answer_booklet_path}`}
                                  target="_blank"
                                >
                                  <span className="material-icons align-middle download_icon">
                                    visibility
                                  </span>
                                </a>
                              </>
                            )}
                        </label>
                        <span className={`ReviewLabel`}>
                          {fdata.answer_booklet_original_path || "_"}
                        </span>
                      </div>
                    </div>
                    {/* 3 */}
                    <div className="col-md-3">
                      <div className={`forms`}>
                        <label
                          htmlFor="inputName"
                          className={` form-label text-muted`}
                        >
                          Question Frame Set
                          {fdata.question_frameset_path !== "" &&
                            fdata.question_frameset_path !== null && (
                              <>
                                <a
                                  href={`${ImageUrlPrefix}/${fdata.question_frameset_path}`}
                                  target="_blank"
                                  download
                                >
                                  <span className="material-icons align-middle download_icon">
                                    file_download
                                  </span>
                                </a>
                                <a
                                  href={`${ImageUrlPrefix}/${fdata.question_frameset_path}`}
                                  target="_blank"
                                >
                                  <span className="material-icons align-middle download_icon">
                                    visibility
                                  </span>
                                </a>
                              </>
                            )}
                        </label>
                        <span className={`ReviewLabel`}>
                          {fdata.question_frameset_original_path || "_"}
                        </span>
                      </div>
                    </div>
                    {/* 4 */}
                    <div className="col-md-3">
                      <div className={`forms`}>
                        <label
                          htmlFor="inputName"
                          className={` form-label text-muted`}
                        >
                          Answer Key
                          {fdata.answer_key_path !== "" &&
                            fdata.answer_key_path !== null && (
                              <>
                                <a
                                  href={`${ImageUrlPrefix}/${fdata.answer_key_path}`}
                                  target="_blank"
                                  download
                                >
                                  <span className="material-icons align-middle download_icon">
                                    file_download
                                  </span>
                                </a>

                                <a
                                  href={`${ImageUrlPrefix}/${fdata.answer_key_path}`}
                                  target="_blank"
                                >
                                  <span className="material-icons align-middle download_icon">
                                    visibility
                                  </span>
                                </a>
                              </>
                            )}
                        </label>
                        <span className={`ReviewLabel`}>
                          {fdata.answer_key_original_path || "_"}
                        </span>
                      </div>
                    </div>
                    {/* 5 */}
                    <div className="col-md-3">
                      <div className={`forms`}>
                        <label
                          htmlFor="inputName"
                          className={` form-label text-muted`}
                        >
                          Cut-Off
                        </label>
                        <span className={`ReviewLabel`}>
                          {fdata.cut_off !== null ? fdata.cut_off : "⎯"}
                        </span>
                      </div>
                    </div>
                    {/* 6 */}
                    <div className="col-md-3">
                      <div className={`forms`}>
                        <label
                          htmlFor="inputName"
                          className={` form-label text-muted`}
                        >
                          Double Evaluation
                        </label>
                        <span className={`ReviewLabel`}>
                          {fdata.double_evaluation === 1 && "Yes"}
                          {fdata.double_evaluation === 0 && "No"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {types === 1 && fdata.method_of_test === 0 && (
            <section className={`StepOne `}>
              <div className={`box row`}>
                <div className="col-md-12 pb-2">
                  <p className={`StepTitle`}>Uploaded Question Paper</p>
                  <div className="row ">
                    <div className="col-md-3">
                      <div className={`forms`}>
                        <label htmlFor="inputName" className={` text-muted`}>
                          Uploaded Question Paper
                          {fdata.qpath !== "" && fdata.qpath !== null && (
                            <a
                              href={`${ImageUrlPrefix}/${fdata.qpath}`}
                              download
                            >
                              <span className="material-icons align-middle download_icon">
                                file_download
                              </span>
                            </a>
                          )}
                        </label>
                        <span className={`ReviewLabel mt-2`}>
                          {fdata.qpath_original_path}
                        </span>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className={`forms`}>
                        <label htmlFor="inputName" className={` text-muted`}>
                          Cut-Off
                        </label>
                        <span className={`ReviewLabel  mt-2`}>
                          {fdata.cut_off !== null ? fdata.cut_off : "⎯"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}

        </div>
      </div>

      {/* {open && (
        <Modal
          key={`modal-0-${0}`}
          show={open}
          onHide={handleModalClose}
          size="xl"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <h5
                className={` fw-bold mb-0`}
                id="exampleModalLabel"
              >
                Recording Url and Attendance Sheet
              </h5>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row global_container">
              <div className="col-12">
                <form className="row g-3">
                  <div className="col-md-6">
                    <label
                      htmlFor="chooseTest"
                      className="form-label confirm_value"
                    >
                      Recording Url
                    </label>
                    <input
                      className="desc_input_text w-100 rounded-2 input-font-size-sm"
                      type="text"
                      id="iframe"
                      name="iframe"
                      placeholder="Enter Recording URL"
                      value={fdata.iframe || ""}
                      onChange={handleChange}
                    />
                  
                  </div>

                  <div className="col-md-6">
                    <div className="forms">
                      <label
                        htmlFor="startDate"
                        className="form-label confirm_value"
                      >
                        Attendance Sheet
                      </label>
                      <input
                        ref={answer_sheet_ref}
                      
                        className={
                          "InputsSelectFile mt-0 vv_upload_width"
                        }
                        type="file"
                        id="formFile"
                        name="AttendancesheetPath"
                        onChange={handleChange}
                        required
                      />
                      {error.AttendancesheetPath && (
                        <small className="error_message">
                          {error.AttendancesheetPath}
                        </small>
                      )}
                    </div>
                  </div>


                </form>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <ul className="List-Button">
              <li className="ListBtnItems">
                <button onClick={handleClose} className="primaryButton border-0">
                  Save
                </button>
              </li>
            </ul>
          </Modal.Footer>
        </Modal>
      )} */}
    </div>
  );
}
